// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"49":"2ab3e38d","93":"10158a82","205":"ffd09101","388":"c8239c0f","632":"54b42884","654":"fadee103","657":"69d9d434","772":"b7bfe374","893":"a991d9be","949":"7e999252"}[chunkId] + ".js";
};